export interface AnnouncementSchedule {
  id: string;
  startAt: Date;
  endAt: Date;
}

export const ANNOUNCEMENT_SCHEDULE: AnnouncementSchedule = {
  id: 'to-c-announcement-2026-08-25',
  startAt: new Date('2026-08-01T00:00:00+09:00'),
  endAt: new Date('2026-09-12T00:00:00+09:00')
};

export function isAnnouncementActive(schedule: AnnouncementSchedule, now: Date = new Date()): boolean {
  return now >= schedule.startAt && now < schedule.endAt;
  // TODO 現状は手動で切り替える
  // return false;
}
